import type { Gift } from "@/components/server/EditSuscription/DeleteAccount/types";
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
} from "@/components/ui/dialog";
import { useNavigate } from "@tanstack/react-router";
import { MarkdownCustom } from "./MarkdownCustom";

type AgradecimientoOfertaProp = {
    open: boolean;
    setClose: () => void;
    gift: Gift;
};

const AgradecimientoOferta = ({
    open,
    setClose,
    gift,
}: AgradecimientoOfertaProp) => {
    const navigate = useNavigate();
    const closeAcepted = () => {
        navigate({ to: "/user/discounts" });
    };

    return (
        <Dialog open={open} onOpenChange={setClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <h2 className="text-center text-2xl font-semibold">
                        {gift.aceptacion.title}
                    </h2>
                </DialogHeader>
                <div className="text-center py-4">
                    <MarkdownCustom>{gift.aceptacion.body}</MarkdownCustom>
                </div>
                <DialogFooter className="flex flex-col sm:flex-row gap-2">
                    <Button
                        variant="outline"
                        onClick={closeAcepted}
                        className="flex-1"
                    >
                        Cerrar
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export { AgradecimientoOferta };
